(function () {
  'use strict';

  const TRANSITIONS = ['fade', 'slide', 'zoom', 'flip', 'push-up', 'dissolve'];

  function initSlideshow(root) {
    const vp      = root.querySelector('.phs__viewport');
    if (!vp) return;

    const track   = vp.querySelector('.phs__track');
    const slides  = Array.from(track.querySelectorAll('.phs__slide'));
    if (!slides.length) return;

    const prevBtn    = vp.querySelector('.phs__nav--prev');
    const nextBtn    = vp.querySelector('.phs__nav--next');
    const dots       = Array.from(vp.querySelectorAll('.phs__dot'));

    const autoOn     = vp.dataset.autoRotate === 'true';
    const intervalMs = (parseInt(vp.dataset.rotateInterval, 10) || 7) * 1000;
    let transition   = vp.dataset.transition || 'fade';

    let current   = slides.findIndex(s => s.classList.contains('is-active'));
    if (current < 0) current = 0;

    let autoId    = null;
    let isPlaying = autoOn;

    /* ── core go-to ─────────────────────────── */
    function goTo(next, dir) {
      if (next === current || next < 0 || next >= slides.length) return;

      const prev = current;
      slides[prev].classList.add('is-prev');

      const doSwap = () => {
        slides[prev].classList.remove('is-active', 'is-prev');
        slides[next].classList.add('is-active');

        dots.forEach((d, i) => {
          d.classList.toggle('is-active', i === next);
          d.setAttribute('aria-selected', String(i === next));
        });

        current = next;
      };

      if (transition === 'fade' && document.startViewTransition) {
        document.startViewTransition(doSwap);
      } else {
        doSwap();
      }

      setTimeout(() => slides[prev].classList.remove('is-prev'), 700);
    }

    /* ── auto-rotate ────────────────────────── */
    function startAuto() {
      if (!isPlaying) return;
      stopAuto();
      autoId = setInterval(() => {
        goTo((current + 1) % slides.length, 1);
      }, intervalMs);
    }

    function stopAuto() {
      clearInterval(autoId);
      autoId = null;
    }

    function restartAuto() {
      if (isPlaying) { stopAuto(); startAuto(); }
    }

    /* ── controls ───────────────────────────── */
    if (nextBtn) nextBtn.addEventListener('click', () => { goTo((current+1)%slides.length, 1); restartAuto(); });
    if (prevBtn) prevBtn.addEventListener('click', () => { goTo((current-1+slides.length)%slides.length, -1); restartAuto(); });

    dots.forEach(d => {
      d.addEventListener('click', () => {
        const t = parseInt(d.dataset.target, 10);
        if (!isNaN(t)) { goTo(t, t > current ? 1 : -1); restartAuto(); }
      });
    });

    /* ── swipe / touch ──────────────────────── */
    let touchX = null;
    track.addEventListener('touchstart', e => { touchX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', e => {
      if (touchX === null) return;
      const dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) < 40) return;
      if (dx < 0) { goTo((current+1)%slides.length, 1); }
      else         { goTo((current-1+slides.length)%slides.length, -1); }
      restartAuto();
    }, { passive: true });

    /* ── keyboard ───────────────────────────── */
    root.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { goTo((current+1)%slides.length, 1); restartAuto(); }
      if (e.key === 'ArrowLeft')  { goTo((current-1+slides.length)%slides.length, -1); restartAuto(); }
    });

    /* ── pause on hover ─────────────────────── */
    if (autoOn) {
      vp.addEventListener('mouseenter', stopAuto);
      vp.addEventListener('mouseleave', () => { if (isPlaying) startAuto(); });
    }

    /* ── start ──────────────────────────────── */
    if (autoOn) startAuto();
  }

  /* ── boot ───────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.phs').forEach(initSlideshow);
  });

  document.addEventListener('shopify:section:load', e => {
    const s = e.target.querySelector('.phs');
    if (s) initSlideshow(s);
  });
})();